import React, { type ReactNode } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { interfaceRtl } from '../i18n/sens';

/**
 * WEB SEULEMENT : le sens de l'interface pour react-native-web.
 *
 * react-native-web résout les propriétés logiques (`marginStart`, `borderStartWidth`, `start`…) en
 * gauche ou droite selon le `dir` de la View parente la plus proche — l'attribut `dir` de la page
 * ne lui suffit pas. Sans cette racine, une interface arabe gardait ses bordures et marges « de
 * début » à gauche (constaté le 17/10/2026). En natif, I18nManager s'en charge : rien n'est ajouté.
 */
export function RacineSens({ children }: { children: ReactNode }) {
  if (Platform.OS !== 'web') return <>{children}</>;
  return (
    <View style={styles.racine} {...({ dir: interfaceRtl() ? 'rtl' : 'ltr' } as object)}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({ racine: { flex: 1 } });
